// src/pages/manager/production/ManagerViewProduction.jsx
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/api";
import ManagerLayout from "../../../layouts/ManagerLayout";

const ManagerViewProduction = () => {
  const superAdminId = JSON.parse(localStorage.getItem("user"))?.superAdminId;
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);

  // fetch all production records
  useEffect(() => {
    async function fetchRecords() {
      const res = await api.get(`/api/production/get-all/${superAdminId}`);
      setRecords(res.data);
    }
    if (superAdminId) fetchRecords();
  }, [superAdminId]);

  // track which ones have been converted
  const converted = JSON.parse(localStorage.getItem("converted") || "[]");

  // flatten records into rows, preserving primaryQuantity
  const rows = records.flatMap((record) =>
    record.items.map((item, idx) => ({
      key: `${record._id}-${idx}`,
      recordId: record._id,
      date: new Date(record.date).toISOString().slice(0, 10),
      product: item.product,
      unit: item.unit,
      secondaryQty: item.secondaryQuantity,
      primaryQty: item.primaryQuantity,
    }))
  );

  return (
    <ManagerLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h5">Production Records</Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/manager/production/create")}
          >
            + New Entry
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Secondary Qty</TableCell>
                <TableCell>Primary Qty</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.key}>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.product}</TableCell>
                  <TableCell>{row.unit}</TableCell>
                  <TableCell>{row.secondaryQty}</TableCell>
                  <TableCell>{row.primaryQty}</TableCell>
                  <TableCell>
                    {!converted.includes(row.recordId) && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          navigate("/manager/pchallan/create", {
                            state: {
                              production: records.find(
                                (r) => r._id === row.recordId
                              ),
                            },
                          })
                        }
                      >
                        Convert to P-Challan
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </ManagerLayout>
  );
};

export default ManagerViewProduction;
